<template>
    <div class="row">
        <div class="small-10 columns">
            <strong>Datenschutz</strong>
            <p style="font-size: small;">
                Ihre Daten werden verschlüsselt übertragen.
                Gerade als Anwaltskanzlei sind wir gesetzlich dazu verpflichtet, Ihre Daten niemals an unbeteiligte
                Dritte weiterzugeben oder gar zu verkaufen.
            </p>
        </div>
        <div class="small-2 columns">
            <img src="../assets/ssl-logo.png" width="60" alt="Datensicherheit durch SSL Verschlüsselung"/>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PrivacyHint'
};
</script>

<style scoped>

</style>
